import React from 'react'
import About from './PAGES/About'
import Contact from './PAGES/Contact'
import Footer from './PAGES/Footer'
import Home from './PAGES/Home'
import Navbar from './PAGES/Navbar'
import Skills from './PAGES/Skills'

const App = () => {
  return (
    <>
    <Navbar/>
    <Home/>
    <About/>
    <Skills/>
    <Contact/>
    <Footer/>
    </>
  )
}

export default App